import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LeapV2EvidenceService } from '../../tutor-reports/tutor-report-flows/tutor-report-leap-v2/services/leap-v2-evidence.service';

/** The API route that serves one generated client report; the generated report id follows it. */
export const CLIENT_REPORT_FILE_PREFIX = 'api/Files/Report/';

/**
 * The page a report-ready email links to (/client-reports/:id). The email never carries a storage link (bug
 * 40444): the recipient signs in, and the report is fetched through the API, which checks they may see it. A PDF is
 * shown here; any other file (a spreadsheet) is saved. A report the caller may not see reads as not found.
 */
@Component({
  selector: 'client-report-view',
  standalone: true,
  templateUrl: './client-report-view.page.html',
})
export class ClientReportViewPage implements OnInit, OnDestroy {
  public state: 'loading' | 'shown' | 'saved' | 'missing' = 'loading';
  public reportUrl: string = null;
  /** The blob: URL of the fetched PDF, for the iframe. Built only from a blob this page created. */
  public reportFrameUrl: SafeResourceUrl = null;

  constructor(private route: ActivatedRoute, private evidenceService: LeapV2EvidenceService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!Number.isInteger(id) || id <= 0) {
      this.state = 'missing';
      return;
    }
    const file = { name: `report-${id}`, url: CLIENT_REPORT_FILE_PREFIX + id };
    // The page shows its own not-found state, so the support modal stays out (40973).
    this.evidenceService.download(file, true).subscribe({
      next: blob => {
        if (blob?.type === 'application/pdf') {
          this.reportUrl = URL.createObjectURL(blob);
          this.reportFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.reportUrl);
          this.state = 'shown';
        } else {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = file.name;
          link.click();
          URL.revokeObjectURL(url);
          this.state = 'saved';
        }
      },
      error: () => this.state = 'missing',
    });
  }

  ngOnDestroy(): void {
    if (this.reportUrl) {
      URL.revokeObjectURL(this.reportUrl);
    }
  }
}